(function () {
  'use strict';
  if (window.RegalonCheckout) return;
  let pending = null;
  const root = () => window.Shopify?.routes?.root || '/';
  const marked = item => String(item.properties?._regalon) === 'true';

  async function request(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      if (!response.ok) throw new Error(`Regalon HTTP ${response.status}`);
      return await response.json();
    } finally { clearTimeout(timer); }
  }
  const cart = () => request(`${root()}cart.js`, { cache: 'no-store' });
  const update = updates => request(`${root()}cart/update.js`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }),
  });
  async function removeGifts() {
    const current = await cart();
    const updates = Object.fromEntries(current.items.filter(marked).map(item => [item.key, 0]));
    if (Object.keys(updates).length) {
      const updatedCart = await update(updates);
      if (typeof document !== 'undefined' && typeof document.dispatchEvent === 'function') {
        document.dispatchEvent(new CustomEvent('regalon:cartSynced', { detail: { cart: updatedCart } }));
      }
    }
  }

  async function prepare(options = {}) {
    let giftIds = new Set();
    try {
      const current = await cart();
      const token = window.customer?.accessToken;
      if (!token) { if (current.items.some(marked)) await removeGifts(); return; }
      const base = window.BACKEND_NODE_BASE_URL;
      const endpoint = base && `${base.replace(/\/$/, '')}/Prod/cart/regalon`;
      if (!endpoint) throw new Error('Regalon API missing');

      const customerId = options?.customerId ||
        (window.isQuickOrder && typeof document !== 'undefined' ? document.querySelector?.('[purchase-order-associate]')?.value : null) ||
        null;

      const payload = {
        subtotalCents: current.items_subtotal_price,
        items: current.items.map(item => ({
          variantId: String(item.variant_id),
          quantity: item.quantity,
          finalTotalCents: item.final_line_price,
          properties: Object.fromEntries(Object.entries(item.properties || {}).filter(([, value]) => typeof value === 'string')),
        })),
      };
      if (customerId && /^[1-9]\d*$/.test(String(customerId).trim())) {
        payload.customerId = String(customerId).trim();
      }

      const result = await request(endpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });
      if (result.status !== 'ELIGIBLE') {
        if (current.items.some(marked)) await removeGifts();
        return;
      }
      if (!Array.isArray(result.gifts) || !result.gifts.length) throw new Error('Invalid Regalon gifts');
      const gifts = result.gifts.map(gift => {
        const id = /^gid:\/\/shopify\/ProductVariant\/([1-9]\d*)$/.exec(gift.variantId)?.[1];
        if (!id || gift.quantity !== 1 || gift.priceCents !== 0) throw new Error('Invalid Regalon gift');
        return { id, quantity: 1, properties: { _regalon: 'true' } };
      });
      giftIds = new Set(gifts.map(gift => gift.id));
      if (giftIds.size !== gifts.length) throw new Error('Duplicate Regalon gifts');
      const updates = {};
      const retained = new Set();
      for (const item of current.items) {
        const id = String(item.variant_id);
        if (!marked(item) && !giftIds.has(id)) continue;
        if (marked(item) && giftIds.has(id) && !retained.has(id) && item.final_price === 0) {
          retained.add(id);
          if (item.quantity !== 1) updates[item.key] = 1;
        } else { updates[item.key] = 0; }
      }
      if (Object.keys(updates).length) await update(updates);
      const missing = gifts.filter(gift => !retained.has(gift.id));
      if (missing.length) await request(`${root()}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: missing }),
      });
      // Verificar el estado real: nunca conservar un beneficio parcial o con costo.
      const changed = Object.keys(updates).length > 0 || missing.length > 0;
      const finalCart = changed ? await cart() : current;
      const actual = finalCart.items.filter(marked);
      if (actual.length !== gifts.length || actual.some(item => !giftIds.has(String(item.variant_id)) || item.quantity !== 1 || item.final_price !== 0) ||
          new Set(actual.map(item => String(item.variant_id))).size !== gifts.length) throw new Error('Regalon cart mismatch');

      if (typeof document !== 'undefined' && typeof document.dispatchEvent === 'function') {
        document.dispatchEvent(new CustomEvent('regalon:cartSynced', { detail: { cart: finalCart } }));
      }
    } catch (error) {
      console.error('[Regalon] BENEFIT_SKIPPED_ERROR', error);
      try { await removeGifts(); } catch (cleanupError) { console.error('[Regalon] Cleanup failed', cleanupError); }
    }
  }
  window.RegalonCheckout = {
    prepare(options) {
      if (!pending) pending = prepare(options).finally(() => { pending = null; });
      return pending;
    },
    removeGifts() {
      return removeGifts();
    },
  };
})();
